import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from "react-redux";
import {Table} from "../../../components";
import {adminToken} from "../../../helper";
import axios from "axios";
import {Loader} from "../index";
import { AWS_ROUTING, AWS_SERVER_APIS } from "../../../configurations";

function RatingTab(props) {
    const [ratingdata, setRatingdata] = useState();
    const transaction = useSelector(state => state.subsDetail?.transaction);
    const [tableRows, setTableRows] = useState();
    // console.log('subscriptionID =-------====>>>>'+JSON.stringify(transaction[0].subscriptionID));
    useEffect(() => {
        adminToken()
        .then(token =>
            axios.get(
                `${AWS_SERVER_APIS}/getcustomerratings?sub_id=${transaction[0].subscriptionID}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            ).then(res => {
                // console.log('res =-------====>>>>'+JSON.stringify(res.data.ratings));
                setRatingdata(res.data.ratings)
                
                let filtered = res.data.ratings;
                // console.log('>>>>>>>>>>>'+JSON.stringify(filtered));
                if (!filtered?.length) {
                    setTableRows();
                    return;
                }
        
                console.log(filtered);
                // Map table rows
                filtered = filtered?.map(obj => ({
                    rating: obj?.sp_rating,
                    description: obj?.description,
                    first_name: obj?.get_user_details?.first_name,
                    last_name: obj?.get_user_details?.last_name,
                    email: obj?.get_user_details?.email,
                    mobile: obj?.get_user_details?.mobile,
                    createdAt: `${new Date(obj?.created_at).toLocaleString()}`,
                    updatedAt: `${new Date(obj?.updated_at).toLocaleString()}`
                }));
        
                setTableRows(filtered);
            }))
    }, []);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Rating",
                sortBy: "rating"
            },
            {
                title: "Description"
            },
            {
                title: "First Name"
            },
            {
                title: "Last Name"
            },
            {
                title: "Email"
            },
            {
                title: "Mobile"
            },
            {title: "Created"},
            {
                title: "Updated",
                sortBy: "updatedAt"
            }
        ],
        [tableRows]
    );
    if(tableRows){
        return <Table headers={tableHeaders} data={tableRows}/>;
    }else{
        return <center><div>No customer ratings have been submitted yet.</div></center>
    }
    
}

export default RatingTab;